module.exports = __webpack_public_path__ + "static/media/education.d5344fb0.svg";